import { AppLanguages, AppRegions } from './app.constants';

export const ACCOUNT_CREATION_DISCLAIMER_URLS = {
  [AppRegions.et]: {
    [AppLanguages.en]: 'https://esto.ee/en/terms-and-conditions',
    [AppLanguages.et]: 'https://esto.ee/et/tingimused-ja-juriidiline-teave',
    [AppLanguages.ru]: 'https://esto.ee/ru/usloviya-i-polozheniya',
    [AppLanguages.lv]: 'https://esto.lv/lv/noteikumi-un-nosacijumi',
    [AppLanguages.lt]: 'https://esto.lt/lt/taisykles-ir-salygos',
  },
  [AppRegions.lv]: {
    [AppLanguages.en]: 'https://esto.ee/en/terms-and-conditions',
    [AppLanguages.et]: 'https://esto.ee/et/tingimused-ja-juriidiline-teave',
    [AppLanguages.ru]: 'https://esto.ee/ru/usloviya-i-polozheniya',
    [AppLanguages.lv]: 'https://esto.lv/lv/noteikumi-un-nosacijumi',
    [AppLanguages.lt]: 'https://esto.lt/lt/taisykles-ir-salygos',
  },
  [AppRegions.lt]: {
    [AppLanguages.en]: 'https://esto.ee/en/terms-and-conditions',
    [AppLanguages.et]: 'https://esto.ee/et/tingimused-ja-juriidiline-teave',
    [AppLanguages.ru]: 'https://esto.ee/ru/usloviya-i-polozheniya',
    [AppLanguages.lv]: 'https://esto.lv/lv/noteikumi-un-nosacijumi',
    [AppLanguages.lt]: 'https://esto.lt/lt/taisykles-ir-salygos',
  },
} as const;
